import { useSyncExternalStore } from 'react';
import { ensureAuthEngine } from '@/lib/authStore';

/**
 * Reader over the app-wide auth engine (src/lib/authStore.ts).
 *
 * The returned shape — { user, session, isLoading, signOut } — is unchanged, so
 * every existing call site keeps working. What changed: the session is resolved
 * ONCE per app load in the engine instead of once per consumer mount.
 */
export function useAuth() {
  const engine = ensureAuthEngine();
  const snapshot = useSyncExternalStore(
    engine.subscribe,
    engine.getSnapshot,
    engine.getSnapshot,
  );

  return {
    user: snapshot.user,
    session: snapshot.session,
    isLoading: snapshot.isLoading,
    signOut: engine.signOut,
  };
}
